import { Component, OnInit, Output, EventEmitter, ViewChild, ViewChildren, ViewContainerRef, QueryList, AfterViewInit, OnDestroy, Input, OnChanges, SimpleChanges, Injector } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatRow, MatTableDataSource } from '@angular/material/table';
import { Observable, Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Roles, PendingResourcesType, FormType, ActionPendingCatalog, StatusPendingCatalog } from 'src/app/common/enumerations/enumerations';
import { BeamlineShutterRelation } from 'src/app/components/catalogs/beamline-catalog/resource/resources';
import { PrivilegeEnum } from 'src/app/common/enumerations/privilege-enum';
import { CatalogService } from '../../catalog-service';
import { PendingCatalogType, PendingResource } from 'src/app/services/pending-approvals/pending-approval';

@Component({
  selector: 'resources-list-new',
  templateUrl: './resources-list-new.component.html',
  styleUrls: ['./resources-list-new.component.scss']
})
export class ResourcesListNewComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

  @Input() selectedTab = 0;
  @Input() filter?: string;
  @Input() beamlineShutter?: BeamlineShutterRelation;
  @Input() beamlineShutterRelations?: BeamlineShutterRelation[];

  @Output() selectedRow = new EventEmitter<BeamlineShutterRelation>();
  @Output() rowSelectionStarted = new EventEmitter<void>();

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChildren('matrow', { read: ViewContainerRef }) rows!: QueryList<ViewContainerRef>;
  @ViewChildren('matrow') datarows!: QueryList<MatRow>;


  public createAvailable!: boolean;

  public selectedRowItem: any;

  public displayedColumns: string[] = ['beamlineName', 'shutterName', 'ketStatus'];
  public dataSource!: MatTableDataSource<BeamlineShutterRelation>;
  public pending = false;

  constructor(
    protected override injector: Injector,
    private _catalogService: CatalogService,
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.selectedTab = isNaN(this.selectedTab) ? this.selectedTab = 0 : this.selectedTab;
    this.createAvailable = this.hasRoles([Roles.ADM]);
    // if (changes['filter']) this.applyFilter(this.filter);
    if (changes['selectedTab']) this.beamlineShutterRelations?.map(b => b.statusClass = this.getColor(b));
    if (changes['beamlineShutter']) {
      if (!this.beamlineShutter?.beamlineId && !this.beamlineShutter?.pendingResources?.length) {
        this.selectedRowItem = null;
      }
    }
    this.loadAllResources();
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.setSortingAccessor();
  }

  override  ngOnDestroy(): void {
    super.ngOnDestroy();
  }


  async loadAllResources() {
    const pendingResource = this._catalogService.pendingCatalog?.approvalType == PendingCatalogType.Beamline ? this._catalogService.pendingCatalog : null;

    this.beamlineShutterRelations?.map(b => b.statusClass = this.getColor(b));
    const hasPrivilege = this.hasPrivilege(PrivilegeEnum.BeamlineCatalog) || this.hasPrivilege(PrivilegeEnum.RSSTestDBAuth);

    this.beamlineShutterRelations = this.beamlineShutterRelations?.filter(x => hasPrivilege || !hasPrivilege && x.beamlineId)
      .sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers(a.beamlineName, b.beamlineName))

    this.dataSource = new MatTableDataSource(this.beamlineShutterRelations);
    if (this.filter) this.applyFilter(this.filter);

    this.setSortingAccessor();

    if (pendingResource) {
      if (pendingResource.id) {
        const index = this.dataSource.data.findIndex(r => r.beamlineId == pendingResource.id);
        this.showIndex(index);
      }
      else {
        const pendingKET = await this.redirect.getDocument(FormType.KET);
        if (pendingKET) {
          const shutterID = pendingKET.locations?.find(l => l.type == this.resourceTypeEnum.Shutter)?.id;
          const index = this.dataSource.data.findIndex(r => r.shutterId == shutterID);
          this.showIndex(index);
        }
      }
    }
  }


  setSortingAccessor() {
    // Define the sorting accessor
    if (this.dataSource) {
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          default:
            return (item as any)[property]; // Fallback to the default property
        }
      };
      this.setSort<BeamlineShutterRelation>(this.dataSource, this.sort);
    }
  }

  applyFilter(filterValue?: string) {
    this.filter = filterValue;
    const beamlineshutterrelations = this.beamlineShutterRelations?.filter(x => {
      const searchStr = (x.beamlineName + ' ' + x.shutterName + ' ' + x.beamlineStatus).toLowerCase();
      return searchStr.includes(filterValue?.trim().toLowerCase() ?? '');
    });
    this.dataSource = new MatTableDataSource(beamlineshutterrelations ?? []);
    this.setSortingAccessor();
  }

  async selectRow(row: BeamlineShutterRelation) {
    if (await this.canDeactivate()) {
      if (row?.beamlineId || row.status == StatusPendingCatalog.New) {
        this.selectedRowItem = row;
        this._catalogService.pendingCatalog = undefined;
        this.rowSelectionStarted.emit();
        this.selectedRow.emit(row);
      }
    }
  }

  getColor(beamlineShutter: BeamlineShutterRelation): string {
    const statusColor = (status: number): string => {
      switch (status) {
        case 1: return 'blue';
        case 2: return 'orange';
        case 3: return 'black';
        case 4: return 'gray';
        default: return '';
      }
    };

    if (this.selectedTab === 0) {
      const pending = this._catalogService.getLastPendingResource(beamlineShutter, PendingResourcesType.Details);
      const showYellow =
        pending && (this.hasPrivilege(PrivilegeEnum.BeamlineCatalog));
      return showYellow ? 'yellow' : statusColor(beamlineShutter.status ?? 1);
    }

    if (this.selectedTab === 1) {
      return statusColor(beamlineShutter.status ?? 1);
    }

    if (this.selectedTab === 2) {
      const pending = this._catalogService.getLastPendingResource(beamlineShutter, PendingResourcesType.Rss_Database);
      const showYellow =
        pending && (this.hasPrivilege(PrivilegeEnum.RSSTestDBEdit) || this.hasPrivilege(PrivilegeEnum.RSSTestDBAuth));

      return showYellow ? 'yellow' : statusColor(beamlineShutter.status ?? 1);
    }

    return '';
  }


  showIndex(id?: number) {
    if ((id ?? 0) >= 0) {
      setTimeout(() => {
        this.showElement(id, 7);
        this.selectRow(this.dataSource.data[id as number]);
        //this.loading.emit(false);
      }, 100);
    }
  }

  showElement(index: number | undefined, height: number) {
    const indexstr = index?.toString();
    const row = this.rows.find(row => row.element.nativeElement.getAttribute('position') === indexstr);
    if (row) {
      const rect = row.element.nativeElement.getBoundingClientRect();
      if ((rect.y <= 0) || ((rect.y + rect.height) > height)) {
        row.element.nativeElement.scrollIntoView(false, { behavior: 'instant' });
      }
      return;
    }
  }

  getPosition(row: any): number {
    const i = this.dataSource.data.findIndex(r => {
      return r.beamlineId == row.id;
    });
    return i;
  }

  getClass(e: BeamlineShutterRelation, type: number) {
    if (e.ketStatus) {
      const t = e.ketStatus;
      switch (type) {
        case 2:
          if (t?.templateStatus == 0) { return ''; }
          if (t?.templateStatus == 1) { return ' indicator ket-active'; }
          if (t?.templateStatus == 2) { return ' indicator ket-new'; }
          break;
        case 1:
          if (t?.activeFullVersion != null && t?.newFullVersions == 0) { return ' indicator ket-active'; }
          if (t?.activeFullVersion != null && t?.newFullVersions != 0) { return ' indicator ket-active-new'; }
          if (t?.activeFullVersion == null && t?.newFullVersions != 0) { return ' indicator ket-new'; }
          return ' indicator';
          break;
        case 0:
          if (t?.activeAbbrVersion != null && t?.newAbbrVersions == 0) { return ' indicator ket-active'; }
          if (t?.activeAbbrVersion != null && t?.newAbbrVersions != 0) { return ' indicator ket-active-new'; }
          if (t?.activeAbbrVersion == null && t?.newAbbrVersions != 0) { return ' indicator ket-new'; }
          return 'indicator ket-inactive';
          break;
      }
    } else {
      return 'indicator';
    }
    return '';
  }

  getTooltipMesssage(beamlineShutter: BeamlineShutterRelation) {
    // Get IDs of other parent beamlines that share this resource
    var otherIDs = this.utils.JSONparse(beamlineShutter?.sharedParentIDs) as number[];
    // Build comma-separated list of other beamline names
    var otherResources = this.beamlineShutterRelations?.filter(r => otherIDs.includes(r.shutterId ?? 0))
      .map(r => r.beamlineName)
      .join(', ') ?? '';
    // Generate restriction message with current and related beamline names
    return this.getMessage('PendingSharedChangesRestrictionMessage').description.replaceAll('{this}', beamlineShutter?.beamlineName ?? '').replaceAll('{other}', otherResources);
  }


}
